import "bootstrap/dist/css/bootstrap.min.css";
import React from "react";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import { Link } from "react-router-dom";
import "./ItemCard.css";
import ImageCarousel from "../ImageCarousel/ImageCarousel";

const ItemCard = ({ title, text, note, link, linkText, images, onDelete, extraActions }) => {
  return (
    <Card className="item-card">
      <div className="item-card-carousel-wrapper">
        <ImageCarousel images={images || []} />
      </div>
      <Card.Body className="item-card-body">
        <Card.Title className="item-card-title">{title}</Card.Title>
        <Card.Text className="item-card-text">
          {text}
          <br /> {/* Ajoute une ligne vide */}
          {note && <strong>{note}</strong>}{" "}
          {/* Affiche la note seulement si elle existe */}
        </Card.Text>
        <div className="item-card-footer">
          <Button variant="primary" as={Link} to={link} className="item-card-button">
            {linkText}
          </Button>
          <div className="item-card-actions">
            {extraActions}
            {onDelete && (
              <Button
                variant="danger"
                size="sm"
                onClick={onDelete}
                title="Supprimer"
                className="item-card-delete"
              >
                <i className="fas fa-trash-alt"></i>
              </Button>
            )}
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default ItemCard;
